import axios from "axios";

export const apiUrl = 'http://mi.slavilov.com';

export const httpService =  axios.create({
    baseURL: `${apiUrl}/`,
    responseType: "json"
});

httpService.interceptors.request.use(request => {
    let token = localStorage.getItem('token');
    if (token) {
        request.headers['X-Authorization'] = token;
    }
    request.headers['X-Content-Type'] = 'application/json';
    request.headers['Content-Type'] = 'application/json';

    return request;
});